<template lang="html">
  <div class="newOrder" >
    <breadcrumb :nameSection = 'nameSection' :listRoutes = 'listRoutes'></breadcrumb>
    <!--<circle-spin v-if="!dataShipment || isLoading"></circle-spin>-->
    <div v-if="dataShipment && !isLoading">
      <div class="status-content">
        <div class="tag-content">



          <span
            v-if="dataShipment.attributes.status >= 1 && dataShipment.attributes.status <= 3"
            class="badge badge-primary badge-grabr"
          >Procesamiento en origen</span>

          <span
            v-if="dataShipment.attributes.status >= 5 && dataShipment.attributes.status <= 7"
            class="badge badge-dark badge-store bg-success"
          >Procesamiento en destino</span>
          <span v-if=" dataShipment.attributes.status == 4"  class="badge badge-dark badge-store bg-danger">Stand-by</span>

          <p v-if="dataShipment.attributes.status == 1">En direccion origen</p>
          <p v-if="dataShipment.attributes.status == 2">Camino a aeropuerto</p>
          <p v-if="dataShipment.attributes.status == 3">Vuelo al destino en curso</p>

          <p v-if="dataShipment.attributes.status == 5">En aeropuerto del destino</p>
          <p v-if="dataShipment.attributes.status == 6">En evaluación</p>
          <p v-if="dataShipment.attributes.status == 7">Evaluación finalizada</p>





        </div>
        <div class="rr" v-if="dataShipment.attributes.status==5 && $store.state.user.attributes.permissions_keys.includes(18)">
          <button
            v-if=" dataOrderCopy!= null && dataOrderCopy.length != 0"
            type="button"
            class="btn btn-primary"
            style="float:right;"
            @click = "beginEvaluationPackages"
          >Iniciar evaluación de  paquetes</button>
        </div>
        <div class="rr" v-if="dataShipment.attributes.status==2 ">
          <button v-if="$store.state.user.attributes.permissions_keys.includes(17)" type="button" class="btn btn-primary" style="float:right;margin-right:15px" @click = "showModalReprogramation" >Reprogramar</button>
          <button v-if="$store.state.user.attributes.permissions_keys.includes(13)" type="button" class="btn btn-primary" style="float:right;" @click = "confirmDepartureShipment">Confirmar despegue</button>

        </div>



        <div class="rr" v-if="dataShipment.attributes.status==3 ">
          <button v-if=" $store.state.user.attributes.permissions_keys.includes(16)" type="button" class="btn btn-primary" style="float:right;" @click = "confirmArrivalShipment">Confirmar llegada</button>

        </div>

      </div>

      <div class="orden-subtitulo text-title">
        <h1>Embarque # {{dataShipment.id}}</h1>
      </div>

      <div class="details-tab">
        <div id="accordion">
          <div class="card">

              <div class="details-content-title collapsed " id="headingclient" data-toggle="collapse" data-target="#collapseclient" aria-expanded="false" aria-controls="collapseclient">

                <span>Datos del embarque</span>

                <div class="details-text up-arrow"></div>

              </div>

              <div id="collapseclient" class=" collapse" aria-labelledby="headingclient">

                <div class="details-content-info" v-if="dataShipment">

                  <div class="details-title-block">

                    <span class="details-title-item">Descripción:</span>
                    <span class="details-title-item" >{{dataShipment.attributes.description}}</span>

                  </div>

                  <div class="details-title-block">

                    <span class="details-title-item">Destino:</span>

                    <span class="details-title-item">{{dataShipment.attributes.destination.attributes.name}}</span>



                  </div>

                  <div class="details-title-block" >

                    <span class="details-title-item">Operador de llegada:</span>
                    <span class="details-title-item" >{{dataShipment.attributes.reciever_operator.attributes.username}}</span>

                  </div>

                  <div class="details-title-block" >

                    <span class="details-title-item" >Fecha de llegada:</span>
                    <span class="details-title-item"  >{{dataShipment.attributes.departure_date|spanishDateTime}}</span>


                  </div>

                  <div class="details-title-block" >

                    <span class="details-title-item" >Fecha de salida:</span>
                    <span class="details-title-item"  >{{dataShipment.attributes.arrival_date|spanishDateTime}}</span>


                  </div>


                </div>

              </div>

          </div>



          <div class="card">
              <div class="details-content-title collapsed " id="headingclient" data-toggle="collapse" data-target="#collapseclient2" aria-expanded="false" aria-controls="collapseclient2">

                <span>Detalles de equipaje</span>

                <div class="details-text up-arrow"></div>

              </div>

              <div id="collapseclient2" class=" collapse" aria-labelledby="headingclient">

                <div class="details-content-info" >
                                  <div class="details-content-info">
                    <div class="card-body">
                      <div class="resumen-type">
                        <div class="vitrinaContainer">
                            <div v-if="dataLuggageCopy.length  > 0" class="vitrina">
                              <ul class="vitrina-100">
                                <li v-for="luggageItem of dataLuggageCopy">
                                  <cardDetailLuggage v-bind:dataLuggage="luggageItem"></cardDetailLuggage>
                                </li>
                              </ul>
                            </div>
                            <div v-else class="vitrina">
                              <p>No hay equipajes asignados</p>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>

                </div>

              </div>

          </div>




          <div class="card">
              <div class="details-content-title collapsed " id="headingclient" data-toggle="collapse" data-target="#collapseclient3" aria-expanded="false" aria-controls="collapseclient3">

                <span>Paquetes</span>

                <div class="details-text up-arrow"></div>

              </div>

              <div id="collapseclient3" class=" collapse" aria-labelledby="headingclient">

                <div class="details-content-info" >
                  <div class="details-content-info">
                    <div class="card-body">
                      <div class="resumen-type">
                        <div class="vitrinaContainer">
                            <div  v-if="dataOrderCopy.length  > 0" class="vitrina">
                              <ul class="vitrina-100">
                                <li v-for="package of dataOrderCopy">

                                  <cardPackage  v-bind:afterSavePackages="true" v-bind:dataPackage="package" ></cardPackage>
                                </li>
                              </ul>
                            </div>
                            <div v-else class="vitrina">
                              <p>No hay paquetes asignados</p>
                            </div>
                        </div>
                      </div>
                  </div>
                </div>
                </div>
              </div>
          </div>

        </div>
      </div>
      <b-modal hide-footer hide-header id="modalReprogramation" ref="modalReprogramation">
        <div class="modal-Content">
          <div class="modal-header">
            <div class="text-center">
              <p>Reprogramación de embarque </p>
            </div>
            <h5 class="modal-title" id="exampleModalLongTitle"></h5>
            <button type="button" class="close" aria-label="Close" @click="hideModalReprogramation">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" id="modal-body">

            <div class="">
              <div  class="form-group">
                <label for="" class="float-left"> Nueva fecha de salida<i data-toggle="tooltip" data-placement="bottom" title="" class="far fa-question-circle"></i></label>
                <input type="date" name="departure_date" max="2100-12-31" v-validate="'required'" class="form-control null" v-model="newDateDeparture">
                <span v-show="errors.has('departure_date')" class="text-danger">{{ errors.first('departure_date') }}</span>
              </div>
              <div  class="form-group">
                <label for="" class="float-left">Nueva hora de salida<i data-toggle="tooltip" data-placement="bottom" title="" class="far fa-question-circle"></i></label>
                <input type="time" name="departure_hour"  v-validate="'required'" class="form-control null" v-model="newHourDeparture">
                <span v-show="errors.has('departure_hour')" class="text-danger">{{ errors.first('departure_hour') }}</span>
              </div>
              <div  class="form-group">
                <label for="" class="float-left">Nueva fecha de llegada<i data-toggle="tooltip" data-placement="bottom" title="" class="far fa-question-circle"></i></label>
                <input type="date" name="arrival_date" max="2100-12-31" v-validate="'required'" class="form-control null" v-model="newDateArrival">
                <span v-show="errors.has('arrival_date')" class="text-danger">{{ errors.first('arrival_date') }}</span>
              </div>
              <div  class="form-group">
                <label for="" class="float-left">Nueva hora de llegada<i data-toggle="tooltip" data-placement="bottom" title="" class="far fa-question-circle"></i></label>
                <input type="time" name="arrival_hour"  v-validate="'required'" class="form-control null" v-model="newHourArrival">
                <span v-show="errors.has('arrival_hour')" class="text-danger">{{ errors.first('arrivaldeparture_hour') }}</span>
              </div>

            </div>
          </div>

          <div class="modal-footer text-center">
            <button type="button" class="btn btn-primary btn-lg" @click="reprogramateShipment" >Reprogramar embarque</button>
          </div>
        </div>
      </b-modal>
    </div>

  </div>

</template>

<script>
import breadcrumb from '@/components/prefab/structures/breadcrumb.vue'
import cardDetailLuggage from "@/components/prefab/items/card-detail-luggage.vue"

import cardPackage from "@/components/prefab/items/card-package.vue"
import { shipmentService } from '@/services/shipment.service'

export default {
  components: {
    cardDetailLuggage,
    cardPackage,
    breadcrumb
  },
  props:['id'],
  data(){
    return{
      newDateDeparture: '',
      newHourDeparture: '',
      newDateArrival: '',
      newHourArrival: '',

      dataShipment: null,
      dataLuggageCopy: [],
      dataOrderCopy: [],

      nameSection: 'Visualizar embarque',
      listRoutes: [{nameRoute:'shipments-list',titleRoute:'Embarques'},
                  {nameRoute:'shipments-show',titleRoute:'Ver embarque'}],

      isLoading:false
    }
  },
  created(){
    shipmentService.getShipmentDetail(this.id,this.getDataShipment);
  },
  methods:{
    getDataShipment(data){
      this.dataShipment = data;
      this.dataLuggageCopy = this.dataShipment.attributes.luggage_items;
      this.dataOrderCopy = this.dataShipment.attributes.packages;
      this.isLoading=false;
    },
    async confirmDepartureShipment(){
      this.isLoading=true;
      let aux;
      aux = await shipmentService.changeStateShipment(this.id,'true');
      if(!aux){
        alert("error al cambiar de estado")
        return
      };
      shipmentService.getShipmentDetail(this.id,this.getDataShipment);
    },
    async reprogramateShipment(){


      if(!(this.newDateDeparture && this.newHourDeparture && this.newDateArrival && this.newHourArrival)){
        alert("Ingrese todos los datos")
        return
      }

      this.isLoading=true;
      let dataObject = new Object();
      dataObject.departure_date = this.newDateDeparture + ' ' + this.newHourDeparture;
      dataObject.arrival_date = this.newDateArrival + ' ' + this.newHourArrival;

      let aux;

      aux = await shipmentService.reprogramationShipmentState(this.id,dataObject);
      console.log(aux)

      // this.hideModalReprogramation();

      if(!aux){
        alert("error al cambiar de estado")
        return
      };
      console.log("dasfasfsafasfsafasgsgasgasgags");

      // this.hideModalReprogramation();
      shipmentService.getShipmentDetail(this.id,this.getDataShipment);
    },
    async confirmArrivalShipment(){
      this.isLoading=true;
      let aux;
      aux = await shipmentService.changeStateShipment(this.id,'false');
      if(!aux){
        alert("error al cambiar de estado")
        return
      };
      shipmentService.getShipmentDetail(this.id,this.getDataShipment);
    },
    async beginEvaluationPackages(){
      this.isLoading=true;
      let aux;
      aux = await shipmentService.changeStateShipment(this.id,'true');
      if(!aux){
        alert("error al cambiar de estado")
        return
      }else{
        this.$router.push({ name: 'shipments-evaluate-package',params:{ id: this.id}});
      }
      this.isLoading=false;
    },
    hideModalReprogramation() {
      this.$refs.modalReprogramation.hide()
    },
    showModalReprogramation() {
      this.$refs.modalReprogramation.show()

    },
  }
}
</script>



// WEBPACK FOOTER //
// shipment-show-view.vue?6b21f060